import { gql } from 'src/__generated__';

export const DELETE_RESUME = gql(`
  mutation DeleteResume($input: DeleteResumeInput!) {
    deleteResume(input: $input) {
      viewer {
        _id
        resumes {
          ...resume
        }
      }
    }
  }
`);
